import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { linkReversed, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.nav `
  padding: 16px 0;
  overflow: hidden;
  color: ${brand.primary.blue};
`;
const BreadcrumbList = styled.ul `
  ${siteWide};
  list-style: none;
  display: flex;
  row-gap: ${fluid(8, 12)};
  flex-wrap: wrap;

  @media (hover: none) {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
const Breadcrumb = styled.li `
  display: inline-flex;
  align-items: center;
  column-gap: 12px;
  color: currentColor;

  &:not(:last-child) {
    margin-right: 12px;
  }

  svg {
    width: 5px;
    height: 10px;
  }
`;
const BreadcrumbLink = styled.a `
  ${paragraphSmall};
  
  &:is(a) {
    ${linkReversed};
    ${fonts.dmSans.regular};
    color: currentColor;
  }

  margin: 0;
`;
const CurrentBreadcrumb = styled.span `
  ${fonts.dmSans.bold}
`;
export const BreadcrumbsStyles = {
    Breadcrumb,
    BreadcrumbLink,
    BreadcrumbList,
    Container,
    CurrentBreadcrumb,
};
